import axios from "axios";
import * as actionTypes from "./constants";

export const getCleaningList = () => {
  return (dispatch, getState) => {
    const hotelId = getState().hotels.selected;
    dispatch({ type: actionTypes.GET_CLEANING_LIST_REQUEST });
    return axios
      .get("/cleaning/hotel/" + hotelId)
      .then(response =>
        dispatch({
          type: actionTypes.GET_CLEANING_LIST_SUCCESS,
          cleaningList: response.data
        })
      )
      .catch(err =>
        dispatch({ type: actionTypes.GET_CLEANING_LIST_REJECT, err })
      );
  };
};

export const createCleaning = cleaning => {
  return dispatch => {
    dispatch({
      type: actionTypes.CREATE_CLEANING_REQUEST
    });
    return axios
      .post("/cleaning", cleaning)
      .then(response =>
        dispatch({
          type: actionTypes.CREATE_CLEANING_SUCCESS,
          cleaning: response.data
        })
      )
      .catch(err =>
        dispatch({ type: actionTypes.CREATE_CLEANING_REJECT, err })
      );
  };
};

export const updateCleaning = cleaning => {
  return dispatch => {
    dispatch({ type: actionTypes.UPDATE_CLEANING_REQUEST });

    return axios
      .put(`/cleaning/${cleaning._id}`, cleaning)
      .then(() =>
        dispatch({
          type: actionTypes.UPDATE_CLEANING_SUCCESS,
          cleaning
        })
      )
      .catch(err =>
        dispatch({ type: actionTypes.UPDATE_CLEANING_REJECT, err })
      );
  };
};

export const removeCleaning = cleaningId => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.REMOVE_CLEANING_REQUEST });
    return axios
      .delete(`/cleaning/${cleaningId}`)
      .then(() => {
        const { socket } = getState().messages;
        dispatch({ type: actionTypes.REMOVE_CLEANING_SUCCESS, cleaningId });
        socket.emit("cleaning:remove", cleaningId);
      })
      .catch(err =>
        dispatch({ type: actionTypes.REMOVE_CLEANING_REJECT, err })
      );
  };
};



// WEBPACK FOOTER //
// ./src/cleaning/actions.js